import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="privacy-policy-page" style={{ minHeight: '100vh', background: '#f8f9fa' }}>
      {/* Header Section */}
      <div style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '4rem 0 2rem',
        marginBottom: '3rem'
      }}>
        <div className="container">
          <div className="text-center text-white">
            <h1 className="display-4 fw-bold mb-3">
              <i className="fas fa-shield-alt me-3"></i>
              Privacy Policy
            </h1>
            <p className="lead mb-2">
              Your privacy is important to us. Learn how we protect and handle your data.
            </p>
            <p className="mb-0 opacity-75">
              <small>Status: Draft | BRAINTONICA EDTECH LLP — WiZiAi</small>
            </p>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mb-5">
        <div className="card shadow-lg border-0 rounded-4">
          <div className="card-body p-5">
            
            {/* Introduction */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-info-circle me-2"></i>
                2.1 Introduction & Scope
              </h2>
              <p className="text-muted">
                This Privacy Policy describes how <strong>BRAINTONICA EDTECH LLP</strong> ("WiZiAi") collects, uses, discloses and protects personal data when you use our Platform (website, Android app, iOS app) and related services.
              </p>
            </section>

            {/* Data Controller */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-user-shield me-2"></i>
                2.2 Data Controller / Data Fiduciary
              </h2>
              <p className="text-muted">
                WiZiAi is the Data Controller / Data Fiduciary responsible for processing personal data collected via the Platform.
              </p>
              <p className="text-muted mb-0">
                <strong>Contact:</strong> <a href="mailto:privacy@wiziai.in" className="text-decoration-none">privacy@wiziai.in</a>
              </p>
            </section>

            {/* Categories of Data */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-database me-2"></i>
                2.3 Categories of Personal Data Collected
              </h2>
              <p className="text-muted mb-3">We may collect the following categories of personal data:</p>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="p-3 bg-light rounded-3">
                    <h5 className="h6 fw-bold mb-2"><i className="fas fa-id-card text-primary me-2"></i>Identity & Contact Data</h5>
                    <p className="mb-0 small text-muted">Name, date of birth, email, phone number, postal address</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-3 bg-light rounded-3">
                    <h5 className="h6 fw-bold mb-2"><i className="fas fa-key text-primary me-2"></i>Account Credentials</h5>
                    <p className="mb-0 small text-muted">Usernames, hashed passwords, profile photo</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-3 bg-light rounded-3">
                    <h5 className="h6 fw-bold mb-2"><i className="fas fa-graduation-cap text-primary me-2"></i>Educational & Test Data</h5>
                    <p className="mb-0 small text-muted">School, grade, test history, responses, scores, progress</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-3 bg-light rounded-3">
                    <h5 className="h6 fw-bold mb-2"><i className="fas fa-credit-card text-primary me-2"></i>Payment & Billing Data</h5>
                    <p className="mb-0 small text-muted">Billing name, payment instrument (card token via gateway)</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-3 bg-light rounded-3">
                    <h5 className="h6 fw-bold mb-2"><i className="fas fa-mobile-alt text-primary me-2"></i>Device & Technical Data</h5>
                    <p className="mb-0 small text-muted">Device identifiers, OS, app version, IP address, logs</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-3 bg-light rounded-3">
                    <h5 className="h6 fw-bold mb-2"><i className="fas fa-chart-line text-primary me-2"></i>Usage Data & Analytics</h5>
                    <p className="mb-0 small text-muted">Pages visited, interactions, timestamps</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-3 bg-light rounded-3">
                    <h5 className="h6 fw-bold mb-2"><i className="fas fa-headset text-primary me-2"></i>Support & Communications</h5>
                    <p className="mb-0 small text-muted">Messages to customer support, feedback</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-3 bg-light rounded-3">
                    <h5 className="h6 fw-bold mb-2"><i className="fas fa-exclamation-triangle text-warning me-2"></i>Sensitive Data</h5>
                    <p className="mb-0 small text-muted">Limited & only with explicit consent: health info, disability status, photos for verification</p>
                  </div>
                </div>
              </div>
              <div className="alert alert-info mt-3 mb-0">
                <i className="fas fa-info-circle me-2"></i>
                We avoid collecting unnecessary sensitive personal data. If you provide sensitive data, we will process it only with explicit consent and additional safeguards.
              </div>
            </section>

            {/* Sources of Data */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-source me-2"></i>
                2.4 Sources of Personal Data
              </h2>
              <p className="text-muted">
                Data is collected directly from you (during registration, tests, profile edits), from your device (app logs), and from third parties (payment processors, authentication providers, parental consent services). We may also collect data from public sources or partner institutions with your consent.
              </p>
            </section>

            {/* Purpose of Processing */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-tasks me-2"></i>
                2.5 Purpose of Processing & Legal Basis
              </h2>
              <p className="text-muted mb-3">We process personal data for the following purposes:</p>
              <ul className="list-unstyled">
                <li className="mb-3">
                  <div className="d-flex">
                    <i className="fas fa-check-circle text-success me-3 mt-1"></i>
                    <div>
                      <strong>To provide the Platform and Services:</strong> account management, delivering tests, storing results <span className="badge bg-light text-dark">Performance of contract</span>
                    </div>
                  </div>
                </li>
                <li className="mb-3">
                  <div className="d-flex">
                    <i className="fas fa-check-circle text-success me-3 mt-1"></i>
                    <div>
                      <strong>Personalization & recommendations:</strong> AI-generated study plans, performance insights and adaptive tests <span className="badge bg-light text-dark">Consent / legitimate interest</span>
                    </div>
                  </div>
                </li>
                <li className="mb-3">
                  <div className="d-flex">
                    <i className="fas fa-check-circle text-success me-3 mt-1"></i>
                    <div>
                      <strong>Payments & billing:</strong> subscription management and fraud prevention <span className="badge bg-light text-dark">Performance of contract</span>
                    </div>
                  </div>
                </li>
                <li className="mb-3">
                  <div className="d-flex">
                    <i className="fas fa-check-circle text-success me-3 mt-1"></i>
                    <div>
                      <strong>Security & fraud prevention:</strong> abuse detection and account protection <span className="badge bg-light text-dark">Legitimate interest</span>
                    </div>
                  </div>
                </li>
                <li className="mb-3">
                  <div className="d-flex">
                    <i className="fas fa-check-circle text-success me-3 mt-1"></i>
                    <div>
                      <strong>Customer support:</strong> responding to queries and appeals <span className="badge bg-light text-dark">Performance of contract</span>
                    </div>
                  </div>
                </li>
                <li className="mb-3">
                  <div className="d-flex">
                    <i className="fas fa-check-circle text-success me-3 mt-1"></i>
                    <div>
                      <strong>Research, product improvement & analytics:</strong> to improve models and course content <span className="badge bg-light text-dark">Consent / anonymized</span>
                    </div>
                  </div>
                </li>
                <li className="mb-0">
                  <div className="d-flex">
                    <i className="fas fa-check-circle text-success me-3 mt-1"></i>
                    <div>
                      <strong>Legal compliance & dispute resolution:</strong> as required by applicable law <span className="badge bg-light text-dark">Legal obligation</span>
                    </div>
                  </div>
                </li>
              </ul>
              <div className="alert alert-warning mt-3 mb-0">
                <i className="fas fa-exclamation-triangle me-2"></i>
                We will ask for explicit consent for sensitive processing (e.g., biometric proctoring, health information) and for training models where user data will be used beyond immediate personalization.
              </div>
            </section>

            {/* Cookies */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-cookie-bite me-2"></i>
                2.6 Cookies & Tracking Technologies
              </h2>
              <p className="text-muted mb-3">
                We use cookies and similar technologies (local storage, SDKs) to provide functionality, remember preferences, and analyze usage. Types of cookies:
              </p>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="border rounded-3 p-3">
                    <h5 className="h6 fw-bold mb-2"><i className="fas fa-star text-danger me-2"></i>Essential Cookies</h5>
                    <p className="mb-0 small text-muted">Required for core functionality (login, security)</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="border rounded-3 p-3">
                    <h5 className="h6 fw-bold mb-2"><i className="fas fa-cog text-primary me-2"></i>Functional Cookies</h5>
                    <p className="mb-0 small text-muted">To remember preferences and settings</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="border rounded-3 p-3">
                    <h5 className="h6 fw-bold mb-2"><i className="fas fa-chart-bar text-info me-2"></i>Analytics Cookies</h5>
                    <p className="mb-0 small text-muted">To measure usage and performance</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="border rounded-3 p-3">
                    <h5 className="h6 fw-bold mb-2"><i className="fas fa-bullhorn text-success me-2"></i>Marketing Cookies</h5>
                    <p className="mb-0 small text-muted">Only with explicit consent</p>
                  </div>
                </div>
              </div>
              <p className="text-muted mt-3 mb-0">
                Users may control cookies via in-app settings and device/browser controls. Deleting cookies may impact functionality.
              </p>
            </section>

            {/* Minors */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-child me-2"></i>
                2.7 Minors & Parental Consent
              </h2>
              <ol className="text-muted">
                <li className="mb-2">If the user is below the age of consent under local law, WiZiAi requires verifiable parental consent before creating an account or processing the minor's personal data. The App will present a parental consent flow where needed.</li>
                <li className="mb-2">Parents/guardians may review, correct, or request deletion of their child's data through the account or by contacting our Grievance Officer.</li>
                <li className="mb-0">WiZiAi limits data collection for minors to what is strictly necessary for educational services and will not serve targeted marketing to minors without explicit parental permission.</li>
              </ol>
            </section>

            {/* Sharing of Data */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-share-alt me-2"></i>
                2.8 Sharing of Personal Data / Third Parties
              </h2>
              <p className="text-muted mb-3">We may share personal data with the following categories of recipients:</p>
              <ul className="list-unstyled">
                <li className="mb-2"><i className="fas fa-angle-right text-primary me-2"></i><strong>Service providers:</strong> hosting providers (AWS, Google Cloud), analytics vendors, payment processors (Razorpay, Stripe), email/SMS gateways — under Data Processing Agreements</li>
                <li className="mb-2"><i className="fas fa-angle-right text-primary me-2"></i><strong>Proctoring or mentoring vendors:</strong> only with explicit consent and contractually required safeguards</li>
                <li className="mb-2"><i className="fas fa-angle-right text-primary me-2"></i><strong>Affiliates and business partners:</strong> only for specified purposes and under contract</li>
                <li className="mb-2"><i className="fas fa-angle-right text-primary me-2"></i><strong>Legal authorities:</strong> to comply with court orders, legal obligations, or to protect rights and safety</li>
                <li className="mb-0"><i className="fas fa-angle-right text-primary me-2"></i><strong>Acquirers:</strong> in connection with a merger, acquisition or sale of assets</li>
              </ul>
              <p className="text-muted mb-0">
                We require third parties to implement reasonable security measures and process data only per our instructions.
              </p>
            </section>

            {/* International Transfers */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-globe me-2"></i>
                2.9 International Transfers
              </h2>
              <p className="text-muted mb-0">
                If we transfer personal data outside your country (cross-border transfers), we will use appropriate safeguards such as standard contractual clauses, adequacy mechanisms where available, or explicit consent. We will inform users when a transfer requires their consent and provide mechanisms to withdraw consent where allowed by law.
              </p>
            </section>

            {/* Data Retention */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-history me-2"></i>
                2.10 Data Retention
              </h2>
              <p className="text-muted mb-3">
                We retain personal data only as long as necessary to fulfill the purposes described or as required by law. Typical retention periods:
              </p>
              <ul className="list-unstyled">
                <li className="mb-2"><i className="fas fa-clock text-primary me-2"></i><strong>Account and subscription records:</strong> retained for the duration of the account + 3–7 years for accounting/legal purposes</li>
                <li className="mb-2"><i className="fas fa-clock text-primary me-2"></i><strong>Test responses and performance analytics:</strong> retained for the duration of service + up to 3 years for benchmarking, unless user requests deletion</li>
                <li className="mb-2"><i className="fas fa-clock text-primary me-2"></i><strong>Support tickets and logs:</strong> 2–5 years</li>
                <li className="mb-0"><i className="fas fa-clock text-primary me-2"></i><strong>Anonymized or aggregated datasets:</strong> retained indefinitely in anonymized form</li>
              </ul>
              <p className="text-muted mb-0">
                On account deletion, we will delete or de-identify data unless retention is required for legal or legitimate business reasons; users will be informed of any such retention.
              </p>
            </section>

            {/* Security Measures */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-lock me-2"></i>
                2.11 Data Security Measures
              </h2>
              <p className="text-muted mb-3">We implement organizational, technical and administrative safeguards including:</p>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="d-flex align-items-start">
                    <i className="fas fa-shield-alt text-success me-2 mt-1"></i>
                    <span className="text-muted">Encryption of data in transit (TLS) and at rest where feasible</span>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="d-flex align-items-start">
                    <i className="fas fa-shield-alt text-success me-2 mt-1"></i>
                    <span className="text-muted">Secure key management and limited access controls</span>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="d-flex align-items-start">
                    <i className="fas fa-shield-alt text-success me-2 mt-1"></i>
                    <span className="text-muted">Role-based access and least privilege for employees and vendors</span>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="d-flex align-items-start">
                    <i className="fas fa-shield-alt text-success me-2 mt-1"></i>
                    <span className="text-muted">Regular penetration testing and security assessments</span>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="d-flex align-items-start">
                    <i className="fas fa-shield-alt text-success me-2 mt-1"></i>
                    <span className="text-muted">Audit logs of access to personal data and administrative actions</span>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="d-flex align-items-start">
                    <i className="fas fa-shield-alt text-success me-2 mt-1"></i>
                    <span className="text-muted">Incident response plan and breach notification procedures</span>
                  </div>
                </div>
              </div>
            </section>

            {/* Rights of Data Principals */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-user-check me-2"></i>
                2.12 Rights of Data Principals
              </h2>
              <p className="text-muted mb-3">Depending on applicable law, you have rights including:</p>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="card border-0 bg-light h-100">
                    <div className="card-body">
                      <h5 className="h6 fw-bold mb-2"><i className="fas fa-eye text-primary me-2"></i>Right to Access</h5>
                      <p className="mb-0 small text-muted">Access your personal data</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card border-0 bg-light h-100">
                    <div className="card-body">
                      <h5 className="h6 fw-bold mb-2"><i className="fas fa-edit text-primary me-2"></i>Right to Rectify</h5>
                      <p className="mb-0 small text-muted">Correct inaccurate data</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card border-0 bg-light h-100">
                    <div className="card-body">
                      <h5 className="h6 fw-bold mb-2"><i className="fas fa-eraser text-primary me-2"></i>Right to Erasure</h5>
                      <p className="mb-0 small text-muted">Right to be forgotten, subject to legal exceptions</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card border-0 bg-light h-100">
                    <div className="card-body">
                      <h5 className="h6 fw-bold mb-2"><i className="fas fa-ban text-primary me-2"></i>Right to Restrict</h5>
                      <p className="mb-0 small text-muted">Restrict or object to processing</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card border-0 bg-light h-100">
                    <div className="card-body">
                      <h5 className="h6 fw-bold mb-2"><i className="fas fa-file-export text-primary me-2"></i>Right to Portability</h5>
                      <p className="mb-0 small text-muted">Export your data, where applicable</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card border-0 bg-light h-100">
                    <div className="card-body">
                      <h5 className="h6 fw-bold mb-2"><i className="fas fa-hand-paper text-primary me-2"></i>Right to Withdraw</h5>
                      <p className="mb-0 small text-muted">Withdraw consent for processing based on consent</p>
                    </div>
                  </div>
                </div>
              </div>
              <p className="text-muted mt-3 mb-0">
                Some rights may be limited where we must retain data for legal compliance or contractual obligations.
              </p>
            </section>

            {/* How to Exercise Rights */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-envelope me-2"></i>
                2.13 How to Exercise Rights & Contact
              </h2>
              <p className="text-muted mb-3">
                To exercise rights, contact <a href="mailto:privacy@wiziai.in" className="text-decoration-none fw-bold">privacy@wiziai.in</a> or use the in-app privacy/request form. We will verify identity before fulfilling requests and respond within statutory timelines. For unresolved grievances, contact our Grievance Officer at the address provided in the Platform.
              </p>
            </section>

            {/* Changes to Policy */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-sync me-2"></i>
                2.14 Changes to the Privacy Policy
              </h2>
              <p className="text-muted mb-0">
                We may update this Privacy Policy. Material changes will be notified through email and in-app notices. Continued use after notice implies acceptance of the updated policy.
              </p>
            </section>

            {/* Grievance Redressal */}
            <section className="mb-0">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-balance-scale me-2"></i>
                2.15 Grievance Redressal Mechanism
              </h2>
              <p className="text-muted mb-0">
                WiZiAi will maintain a Grievance Officer to address complaints within timelines mandated by applicable law. Contact details are available in the app and on the website.
              </p>
            </section>

          </div>
          
          {/* Footer */}
          <div className="card-footer bg-light text-center py-4">
            <p className="mb-3 text-muted">
              <i className="fas fa-file-pdf text-danger me-2"></i>
              Need a PDF copy of this policy?
            </p>
            <a 
              href="/privacy_policy.pdf" 
              download="WiZiAi_Privacy_Policy.pdf"
              className="btn btn-primary me-3"
              style={{
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                border: 'none'
              }}
            >
              <i className="fas fa-download me-2"></i>
              Download PDF
            </a>
            <a 
              href="/privacy_policy.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-outline-secondary"
            >
              <i className="fas fa-external-link-alt me-2"></i>
              Open PDF
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
